import { useSyncExternalStore } from 'react';
import {
  getBlockedUserIds,
  subscribeBlockedUserIds,
} from '../data/blockedUsers';

/**
 * 차단 ID 집합을 구독해 변경 시 리렌더한다.
 * 차단/해제로 set 이 바뀌면 community 목록/상세가 즉시 재필터된다.
 */
export function useBlockedUserIds(): ReadonlySet<string> {
  return useSyncExternalStore(
    subscribeBlockedUserIds,
    getBlockedUserIds,
    getBlockedUserIds,
  );
}
